import { render, staticRenderFns } from "./StockCatalog.vue?vue&type=template&id=79b837df&scoped=true"
import script from "./StockCatalog.vue?vue&type=script&lang=js"
export * from "./StockCatalog.vue?vue&type=script&lang=js"
import style0 from "./StockCatalog.vue?vue&type=style&index=0&id=79b837df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b837df",
  null
  
)

export default component.exports